import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { getTranslation } from "../locales";

interface SubmittedResponseThankyouProps {
  locale?: string;
  customTitle?: string | null;
  customSubtitle?: string | null;
  customMessage?: string | null;
}

const SubmittedResponseThankyou: React.FC<SubmittedResponseThankyouProps> = ({
  locale = "en",
  customTitle,
  customSubtitle,
  customMessage,
}) => {
  const theme = useTheme();
  const t = getTranslation(locale);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "40px",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f8f9fa",
          padding: "60px",
          borderRadius: "12px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          maxWidth: "700px",
          width: "100%",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: theme.palette.primary.main,
            marginBottom: "30px",
            fontSize: "3rem",
            fontWeight: "bold",
          }}
        >
          {customTitle || t.thankYou}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontSize: "1.4rem",
            color: "#6c757d",
            marginBottom: "25px",
            lineHeight: "1.6",
          }}
        >
          {customSubtitle || t.surveySubmitted}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontSize: "1.2rem",
            color: "#6c757d",
            lineHeight: "1.6",
          }}
        >
          {customMessage || t.appreciateParticipation}
        </Typography>
      </Box>
    </Box>
  );
};

export default SubmittedResponseThankyou;
